export default "__VITE_ASSET__C8pbgf3___"